// extracted by mini-css-extract-plugin
module.exports = {"rounding-amount":"_3_4rPtOLweuOSeJgco294U"};